/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ nights: NonNullable<unknown> }} Picker_Nights_SelectedInputs */

const en_picker_nights_selected = /** @type {(inputs: Picker_Nights_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.nights} nights selected`)
};

/**
* | output |
* | --- |
* | "{nights} nights selected" |
*
* @param {Picker_Nights_SelectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const picker_nights_selected = /** @type {((inputs: Picker_Nights_SelectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Picker_Nights_SelectedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_picker_nights_selected(inputs)
});